// extracted by mini-css-extract-plugin
export var cardWrapper = "linkedOts-module--cardWrapper--c7261";
export var slide = "linkedOts-module--slide--4ed71";
export var swipperContainer = "linkedOts-module--swipperContainer--d8826";